var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import styled from '@emotion/styled';
import SVG from "../../layouts/SVG.js";
export var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15L12 7.5L19.5 15",
    stroke: "currentcolor"
  }));
};
export var ChevronDown = styled(ChevronUp)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transform: scaleY(-1);\n"])));
export var ChevronForward = styled(ChevronUp)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transform: ", ";\n"])), function (props) {
  // @ts-ignore
  return props.theme.isRtl ? "rotate(-90deg)" : "rotate(90deg)";
});
export var ChevronBackward = styled(ChevronUp)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transform: ", ";\n"])), function (props) {
  // @ts-ignore
  return props.theme.isRtl ? "rotate(90deg)" : "rotate(-90deg)";
});